import UpdateProjectTagsItem from '../../../../../../projects/task/i-service/models/tag/request/UpdateProjectTagsItem';

/**
 * * Модель запрса на обновление тегов проекта
 */
export default class UpdateProjectTagsRequest  {
	/**
	 * * Список тегов
	 */
	Tags!: Array<UpdateProjectTagsItem>;
	/**
	 * * Номер проекта
	 */
	ProjectId!: number;
	constructor(obj?: Partial<UpdateProjectTagsRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
